/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-variant-switch component
 */

@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;

// component name
$component: 'zr-variant-switch';

:host {
    --zr-variant-switch-gutter: 14px;
    --zr-variant-switch-measure: 20px
}

.#{$component}__controls {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .#{$component}__headline {
        margin: 0;
        color: var(--ci-neutral800);
    }

    .#{$component}__arrows {
        display: flex;
        align-items: center;
    }
}

.#{$component}__toggle,
.#{$component}__toggle--prev,
.#{$component}__toggle--next{

    cursor: pointer;
    opacity: .8;

    &::before {
        height: var(--zr-variant-switch-measure);
        width: var(--zr-variant-switch-measure);
    }

    &:active {
        opacity: .2;
    }

    &.hide-arrow {
        visibility: hidden;
    }
}

.#{$component}__toggle--prev {
    @include i.get-icon-only(arrow-left);

    margin-right: var(--zr-variant-switch-gutter);
}

.#{$component}__toggle--next {
    @include i.get-icon-only(arrow-right);

    margin-left: var(--zr-variant-switch-gutter);
}

.#{$component}__toggle--desktop {
    display: none;
}

.#{$component}__container-inner {
    display: flex;
    max-width: 100%;
    overflow: auto hidden;
    gap: 8px;
    padding: 8px 0;
}

.#{$component}__legend {
    font-size: 16px;
    margin: 0;
    border: none;
}

// media query: tablet and above
@media only screen and (min-width: $tablet-screen) {
    .#{$component}__controls {
        display: none;
    }

    .#{$component}__container {
        display: flex;
        flex-direction: row;
        gap: 8px;
        width: 100%;
        justify-content: space-between;

        .#{$component}__toggle--desktop,
        .#{$component}__toggle--desktop--prev,
        .#{$component}__toggle--desktop--next {
            border: 1px solid var(--ci-neutral300);
            border-radius: 50%;
            padding: 8px;
            cursor: pointer;
            display: inline-block;
            margin: auto 0;
            opacity: .8;

            &:active {
                opacity: .2;
            }

            &.hide-arrow {
                visibility: hidden;
            }
        }

        .#{$component}__toggle--desktop--prev {
            @include i.get-icon-only(arrow-left);
        }

        .#{$component}__toggle--desktop--next {
            @include i.get-icon-only(arrow-right);

            order: 3;
        }
    }
}
